<template>
    <div class="card">
        <div class="card-img-wrapper">
            <img :src="`${publicPath}${image_bg}`" class="card-img-top" :alt="title">
            <div class="card-icon-service text-center">
                <div class="card-icon-service-content w-100">
                    <img class="d-inline-block" :src="`${publicPath}${image_icon}`" :alt="title">
                    <span class="d-block font-weight-bold text-primary h6">{{title}}</span>
                </div>
            </div>
        </div>
        <div class="card-body mt-8 mt-md-6 d-flex" style="flex-direction: column;justify-content: space-between;">
            <div class="card-text">{{text}}</div>
            <div class="d-lg-flex align-items-lg-center justify-content-lg-between text-center text-lg-left mt-3 small">
                <div><a @click="$bvModal.show(id_modale)" class="text-primary">{{detail_text}} <img src="../assets/svg/play-icon-blue.svg" class="ml-1" height="18" alt=""></a></div>
                <div class="mt-2 mt-lg-0"><RichiestaContatto :button="cta_text" :subject="title"></RichiestaContatto></div></div>
        </div>
        <b-modal :id="id_modale" size="xl" hide-footer @show="track('file_download','presentation',title)">
            <div slot="modal-title">
                <div class="d-flex align-items-center">
                <img height="40" :src="`${publicPath}${image_icon}`" :alt="title"> <span class="font-weight-bold text-primary h3 m-0 ml-3">{{title}}</span>
            </div>
                </div>
            <div class="embed-responsive embed-responsive-16by9">
                <iframe :src="url_video" width="640" height="360" frameborder="0"  autoplay="autoplay" loop="loop" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import RichiestaContatto from './RichiestaContatto'
    import Analytics from '../util/analytics'
    export default {
        name: "Card",
        components: {
            RichiestaContatto
        },
        props: [
            'title',
            'image_bg',
            'image_icon',
            'text',
            'detail_text',
            'cta_text',
            'detail_dest',
            'cta_dest',
            'url_video'
        ],data () {
            return {
                publicPath: process.env.BASE_URL
            }
        },computed: {
            id_modale() {
                return this.title.replace(' ','_')
            }
        },methods: {
            track(action, category, label, detail) {
                Analytics.track(action, category, label, detail);
            }
        }
    }
</script>

<style scoped>

</style>
